var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:(_vm.cssProps)},[_c('router-view',{staticClass:"router-view"}),_c('Loading',{attrs:{"visible":_vm.loading}}),_c('Alert',{ref:"alert"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }